module.exports = __webpack_public_path__ + "static/media/single-product-01.e4054826.jpg";